class NotificationModel {
    constructor(message, type) {
        this.message = message;
        this.type = type;
    }
}

export default NotificationModel;